import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import styled from "styled-components";
import {useFadeIn} from "../../hooks/useFadeIn";
import {
    MANAGE_SCHEMA_MODES, setBackSchemaStateField,
    setFrontSchemaStateField,
    setFrontSchemaTablesMode
} from "../../../features/schemaManageSlice";
import {SchemaI} from "../../../Types";
import {ICONS, LANG} from "../../CONSTANTS";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {modeMap} from "../front/AsideFrontFieldsSection";
import {schemas} from "../../../config";
import {apiFetch} from "../../util";
import {toast} from "react-toastify";


type AsideFrontSchemaI = {};
export default function AsideHeaderBackSchemaFunc({}: AsideFrontSchemaI) {

    let dispatch = useAppDispatch();
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const projectName = useAppSelector(state => state.project.name);
    const selectedTable = useAppSelector(state => state.schemaManage.back.selectedTable);
    const table = useAppSelector(state => state.schemaManage.back.tables[selectedTable!!]);
    const [isArchiveOpen, setIsArchiveOpen] = useState(false);
    const style = useFadeIn(); // or useFadeIn({ delay: 100, duration: 500 })
    const schema = schemas[projectName]

    async function dummy() {
        const {success, message, error} = await apiFetch(`${schema.backend}/astra/saveSchema.php`, {
            method: "POST",
            body: JSON.stringify({
                project: projectName,
                type: "table",
                data: table
            })
        });
        if (success && message)
            toast.success(message)
    }


    return <Container style={style}>
        <div className="selected-table">{selectedTable}</div>
        <div className="modes">
            {MANAGE_SCHEMA_MODES.map(m => <Btn $active={m === mode} className="btn-cmn"
                                               key={m}
                                               disabled={m === "edit" && (!table || table.type === "static")}
                                               onClick={() => dispatch(setBackSchemaStateField("mode", m))}>
                <FontAwesomeIcon size={"lg"} icon={ICONS[modeMap[m].icon]} className={'fa-secondary-color-text'}/>
            </Btn>)}
        </div>
        <div className="controls">
            <button className={'btn-cmn'} onClick={dummy}>
                ЗБЕРЕГТИ
            </button>
        </div>
    </Container>
}

const Btn = styled.button<{ $active: boolean }>`
    flex-grow: 1;
    width: 100%;
    border-bottom: 2px solid ${props => props.$active ? "var(--secondary-text)" : "transparent"};

`

const Container = styled.div`

    display: flex;
    flex-flow: column;
    gap: .5rem;
    padding-left: 1rem;
    padding-right: 1rem;

    opacity: 0;

    .modes {
        display: flex;
        justify-content: center;
        gap: .5rem;
    }

    .selected-table {
        display: flex;
        justify-content: center;
        text-align: center;
        background: var(--secondary-text);
        color: var(--table-action-color);
        padding: .4rem;
        border-radius: .2rem;
        font-weight: bold;
        font-size: 1.1rem;
    }

    .controls {
        display: flex;
        flex-flow: column;
        gap: .5rem;
    }
`
